function VpButtonProps(props, fallbackId) {
  const {
    _iconOnly,
    asChild,
    children,
    disabled,
    endSlot,
    href,
    id = fallbackId,
    loading,
    loadingScreenReaderText,
    loadingSlot,
    shape,
    size,
    startSlot,
    type,
    variant,
    variantStyle,
    ...restProps
  } = props;
  delete restProps.forward;
  delete restProps.spreadEvents;
  delete restProps.ref;
  return {
    logicProps: {
      _iconOnly,
      disabled,
      href,
      id,
      loading,
      loadingScreenReaderText,
      shape,
      size,
      type,
      variant,
      variantStyle
    },
    frameworkProps: {
      as: asChild ? undefined : href ? "a" : "button",
      asChild,
      children,
      endSlot,
      loadingSlot,
      startSlot
    },
    spreadableProps: restProps
  };
}

export { VpButtonProps };
